import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminInquiryModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminInquiryModule;